import T from "../../theme";
import { Icon } from "./Icon";

export const inp = (err) => ({
  width: "100%",
  background: T.card,
  border: `1px solid ${err ? T.danger : T.border}`,
  borderRadius: T.radius,
  padding: "9px 13px",
  color: T.text,
  fontSize: 14,
  outline: "none",
  transition: "border 0.15s",
});

export const Field = ({ label, children, error, hint }) => (
  <div style={{ marginBottom: 16 }}>
    {label && (
      <label style={{ display: "block", fontSize: 13, fontWeight: 500, color: T.textMid, marginBottom: 6 }}>
        {label}
      </label>
    )}
    {children}
    {error && (
      <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 5, color: T.danger, fontSize: 12 }}>
        <Icon name="alert" size={12} color={T.danger} />{error}
      </div>
    )}
    {hint && !error && (
      <div style={{ marginTop: 4, color: T.textLight, fontSize: 12 }}>{hint}</div>
    )}
  </div>
);
